import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {Observable} from "rxjs";
import {BaseModel} from "../models/BaseModel";
import {Organization, PaymentInfo} from "../models/Organization/organizationResponse";
import {Account} from "../models/account/account";

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  constructor(private http: HttpClient) {
  }

  private apiUrl = environment.apiConfig.uri + '/api/externalaccount';

  getInfo(): Observable<BaseModel<Account>> {
    return this.http.get<BaseModel<Account>>(`${this.apiUrl}/getinfo`);
  }



  getPaymentInfo(): Observable<BaseModel<PaymentInfo>> {
    return this.http.get<BaseModel<PaymentInfo>>(`${this.apiUrl}/getpayment`);
  }

  addPaymentInfo(formData: any): Observable<BaseModel<any>> {

    return this.http.post<BaseModel<PaymentInfo>>(`${this.apiUrl}/savepayment`, formData);
  }

  save(formData: any): Observable<BaseModel<any>> {
    return this.http.post<BaseModel<Organization>>(`${this.apiUrl}/save`, formData);
  }
}

